var _style, _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6063251581583147612(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2,
    y1: 14.8,
    x2: 27.6,
    y2: 14.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#e5334e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#a81670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960e7a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 6.3h-2.2V4.9c0-1.6-1.3-2.9-3-2.9s-3 1.3-3 2.9v1.3H2v8.1h10.4v-8zM6.2 4.9c0-.5.4-.9 1-.9s1 .4 1 .9v1.3h-2V4.9zm4.2 7.5H4V8.3h6.4v4.1zm4 6.5h-2.5v-2.5h2.5v2.5zm13.2-8.1v13.8c0 1.7-1.3 3-3 3H10.8c-1.7 0-3-1.3-3-3v-8.2h2v8.2c0 .6.4 1 1 1h13.9c.6 0 1-.4 1-1V10.8c0-.6-.4-1-1-1H14.4v-2h10.2c1.7 0 3 1.3 3 3zM11.9 20.9h2.5v2.5h-2.5v-2.5zm4.5-4.5h2.5v2.5h-2.5v-2.5zm7-2h-2.5v-2.5h2.5v2.5zm-2.5 6.5h2.5v2.5h-2.5v-2.5zm0-4.5h2.5v2.5h-2.5v-2.5zm-2-2h-2.5v-2.5h2.5v2.5zm-2.5 6.5h2.5v2.5h-2.5v-2.5z",
    fill: "url(#SVGID_1_)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6063251581583147612);
export default __webpack_public_path__ + "static/media/6063251581583147612.1e9a2c05169e1d3e9e185d7d950e6969.svg";
export { ForwardRef as ReactComponent };